import Helper from "./Helper";
import Swiper from "swiper/bundle";

class HeaderImageAnimation {
  constructor(config = {}) {
      const {
        selector,
      } = config;
      this.selector = selector;
      this.containers = document.querySelectorAll(this.selector);

      this.bindEvents();
    }

    bindEvents() {
      this.containers.forEach((container, index) => {
        var fadeStart = function(e) { 
          arr[1].classList.add('zoom-in');
        };
        var fadeComplete = function(e) { 
          arr[0].classList.remove('zoom-in'); 
          container.appendChild(arr[0]); 
        };
        var arr = container.getElementsByClassName('ns-header-animation__item');
        for(var i=0; i < arr.length; i++) {
          arr[i].addEventListener("animationstart", fadeStart, false);
          arr[i].addEventListener("animationend", fadeComplete, false);
        }

        arr[0].classList.add('zoom-in');
      });
      
    }

}

export default HeaderImageAnimation;
